import { z } from 'zod';


export const groupsSchema = z.object({
  id: z.number().int().optional(),
  nome: z
    .string()
    .min(3, "O nome deve ter no mínimo 3 caracteres")
    .refine(value => value.trim() !== "", "O nome não pode ser vazio"),

  descricao: z
    .string()
    .optional(),

  unidade: z.object({
    id: z.union([z.number().int(), z.string()])
  })
});

export type GroupsFormData = z.infer<typeof groupsSchema>;
